import { render, staticRenderFns } from "./pcRouteView.vue?vue&type=template&id=3de8d8d0&scoped=true&"
import script from "./pcRouteView.vue?vue&type=script&lang=js&"
export * from "./pcRouteView.vue?vue&type=script&lang=js&"
import style0 from "./pcRouteView.vue?vue&type=style&index=0&id=3de8d8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de8d8d0",
  null
  
)

export default component.exports